var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M7.70831 7L11.2972 2.72207C11.3573 2.65098 11.3067 2.54297 11.2138 2.54297H10.1228C10.0585 2.54297 9.99698 2.57168 9.9546 2.6209L6.99464 6.14961L4.03468 2.6209C3.99366 2.57168 3.93214 2.54297 3.86652 2.54297H2.7755C2.68253 2.54297 2.63195 2.65098 2.6921 2.72207L6.28097 7L2.6921 11.2779C2.67863 11.2938 2.66998 11.3132 2.66719 11.3338C2.6644 11.3544 2.66759 11.3754 2.67637 11.3942C2.68515 11.4131 2.69916 11.429 2.71673 11.4402C2.7343 11.4513 2.7547 11.4571 2.7755 11.457H3.86652C3.93077 11.457 3.9923 11.4283 4.03468 11.3791L6.99464 7.85039L9.9546 11.3791C9.99562 11.4283 10.0571 11.457 10.1228 11.457H11.2138C11.3067 11.457 11.3573 11.349 11.2972 11.2779L7.70831 7Z",
          fill: "#010A11",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }